import React, { useEffect, useState } from "react";
import CustomInputField from "../../../../customInputField";

const ProfessionalOrganization = ({
  professionaInfo,
  handleChange,
  originalProfessionalInfo,
}) => {
  const [activeButton, setActiveButton] = useState(0);

  useEffect(() => {
    professionaInfo &&
      setActiveButton(professionaInfo?.enable_virtual_sessions);
  }, [professionaInfo]);

  const {
    organization_name = "",
    license_number = "",
    practice_since = "",
    state = "",
  } = professionaInfo || {};

  const handleButtonClick = (e) => {
    setActiveButton(e.target.value);
    handleChange(e);
  };

  const buttonStyleYes = {
    backgroundColor: activeButton == 1 ? "#1E90FE" : "",
    color: activeButton == 1 ? "white" : "black",
  };

  const buttonStyleNo = {
    backgroundColor: activeButton == 0 ? "#1E90FE" : "",
    color: activeButton == 0 ? "white" : "black",
  };
  return (
    <div className="border border-solid border-[#EBEFF3] p-5 rounded-md mb-6 bg-white">
      <h5 className="text-base font-bold leading-[160%] text-customGray mb-4">
        Practice or Organization
      </h5>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 dark-field">
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            Practice/Organization name
          </h6>
          <CustomInputField
            placeHolder="Organization Name"
            value={organization_name}
            onChange={handleChange}
            name="organization_name"
            classes="bg-white lg:h-[60px] flex items-center w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] h-[48px] lg:h-[60px] pr-[20px] bg-transparent"
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            Licensed number
          </h6>
          <CustomInputField
            placeHolder="000000000"
            value={license_number}
            onChange={handleChange}
            name="license_number"
            classes="bg-white mb-0 lg:h-[60px] flex items-center w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] h-[48px] lg:h-[60px] pr-[20px] bg-transparent"
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            practice since
          </h6>
          <CustomInputField
            placeHolder="year"
            value={practice_since}
            onChange={handleChange}
            name="practice_since"
            classes="bg-white mb-0 lg:h-[60px] flex items-center w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] h-[48px] lg:h-[60px] pr-[20px] bg-transparent"
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-5">
            I TAKE VIRTUAL PATIENTS (enables Virtual sessions)
          </h6>
          <div className="flex items-center gap-[14px]">
            <button
              className="text-base font-medium leading-[160%] text-white border border-solid border-[#EBEFF3] rounded-[10px] py-[6px] px-[18px]"
              style={buttonStyleYes}
              onClick={(e) => handleButtonClick(e)}
              value={1}
              name="enable_virtual_sessions"
              key={"enable_virtual_sessions_yes"}
            >
              Yes
            </button>
            <button
              className="text-base font-medium leading-[160%] text-customGray border border-solid border-[#EBEFF3] rounded-[10px] py-[6px] px-[18px]"
              style={buttonStyleNo}
              onClick={(e) => handleButtonClick(e)}
              value={0}
              name="enable_virtual_sessions"
              key={"enable_virtual_sessions_no"}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfessionalOrganization;
